/* eslint-disable */
import { Field } from 'Util/Query';

/** @namespace Scandipwa/Query/CategoryList/Query */
export class CategoryListQuery {
    getQuery(filters) {
        return new Field(
            'categoryList'
        )
        .addArgument('filters', 'CategoryFilterInput', filters)
        .addFieldList([
            'name',
            'url_path'
        ])
    }
}

export default new CategoryListQuery();
